/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Field_Active1Inputs */

const vi_guidevideo_field_active1 = /** @type {(inputs: Guidevideo_Field_Active1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiện cho nhân viên`)
};

/**

* @param {Guidevideo_Field_Active1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_field_active1 = /** @type {((inputs?: Guidevideo_Field_Active1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Field_Active1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_field_active1(inputs)
});
export { guidevideo_field_active1 as "guideVideo_field_active" }